import { FormatDate } from "commonFunctions/commonFunctions";
import React, { useMemo } from "react";
import { RenderEpicMessage, RenderOnbaseMessage } from "./RenderMessages";

const PatientTable = (props) => {
    return <table>
        <tr>
            <th>Name</th>
            <th>DOB</th>
            <th>MRN</th>
            {props.data?.onbase_confirmation && <th style={{ textAlign: "center", width: "150px" }}>Readabl Upload to Onbase Status</th>}
            {props.data?.epic_confirmation && <th style={{ textAlign: "center" }}>EPIC Status</th>}
        </tr>
        <tr>
            <td>{props.data?.official_name}</td>
            <td>{props.data?.DOB && FormatDate({ date: props.data?.DOB, format: "MM/DD/YYYY" })}</td>
            <td>{props.data?.MRN}</td>
            {props.data?.onbase_confirmation && <td><RenderOnbaseMessage data={props.data} /></td>}
            {props.data?.epic_confirmation && <td ><RenderEpicMessage data={props.data} /></td>}

        </tr>
    </table>
}

export default PatientTable;